import React from 'react';
import { InputNumber } from 'antd';
import { GlobalVariable } from '@kemu-io/kemu-core/common/managers/globalVariables.js';
import { DataType, SupportedTypes } from '@kemu-io/hs-types';
import styles from '../GlobalVariablesPanel.module.css';
import classNames from 'classnames';

type Props = {
  variable: GlobalVariable;
  onChange: (name: string,value: SupportedTypes, type: DataType) => void;
}

/**
 * Number control component for global variables
 * @param variable - The global variable configuration
 * @param onChange - Callback when value changes
 */
const NumberControl = ({ variable, onChange }: Props) => {
  const handleChange = (value: number | null) => {
    onChange(variable.name, value ?? 0, DataType.Number);
  };

  return (
    <InputNumber
      value={variable.lastValue as number ?? 0}
      onChange={handleChange}
      className={classNames(styles.ControlInput, styles.NumberControl)}
      placeholder="Enter number"
      style={{ width: '100%' }}
    />
  );
};

export default NumberControl;
